import { Skeleton } from "@mui/material";
import { useState } from "react";
import { getPaymentDesc } from "../../classes/stripe/functions/paymentMethods.tsx";
import { useTranslation } from "react-i18next";
import { getCustomerDesc } from "../../classes/stripe/functions/customer.tsx";

export function TablePaymentMethod({id, customerId}) {
    const { t } = useTranslation();

    const [desc, setDesc] = useState(null);

    async function getDesc() {
        const desc = await getPaymentDesc(id, customerId);
        setDesc(desc.getDesc() !== null ? desc.getDesc() : '');
    }

    if (desc === null) {
        getDesc();

        return <div>
            <Skeleton variant="text" width={'100%'}/>
        </div>
    }

    return <div>
        {desc.length === 0 ? t('customers.noMethod') : desc}
    </div>
}

export function TableCustomer({id}) {
    const { t } = useTranslation();

    const [desc, setDesc] = useState(null);

    async function getDesc() {
        const desc = await getCustomerDesc(id);
        setDesc(desc.getDesc() !== null ? desc.getDesc() : '');
    }

    if (desc === null) {
        getDesc();

        return <div>
            <Skeleton variant="text" width={'100%'}/>
        </div>
    }

    return <div>
        {desc.length === 0 ? t('customers.noCustomer') : desc}
    </div>
}